import React, { useEffect } from "react";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import MobileBottomNav from "@/components/layout/MobileBottomNav";
import FloatingActions from "@/components/layout/FloatingActions";
import { trackEvent } from "@/lib/api";

export default function PublicLayout({ children, waMessage }) {
  useEffect(() => {
    document.documentElement.classList.add("theme-light");
    trackEvent("page_view", { path: window.location.pathname });
    window.scrollTo(0, 0);
    return () => document.documentElement.classList.remove("theme-light");
  }, []);
  return (
    <div className="min-h-screen bg-[#F8FAFC] text-slate-800 flex flex-col">
      <Navbar />
      <main className="flex-1 pb-16 md:pb-0">{children}</main>
      <Footer />
      <MobileBottomNav />
      <FloatingActions waMessage={waMessage} />
    </div>
  );
}
